export default {
  getAllEmailTemplate: [],
  getEmailConfig: [],
  resetEmail: "",
};
